import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/getmylink")({
  component: GetMyLinkRedirect,
  head: () => ({
    meta: [
      { title: "Redirecting..." },
      { name: "robots", content: "noindex, nofollow" },
      {
        name: "description",
        content: "Redirecting to GoDaddy.",
      },
    ],
  }),
});

function GetMyLinkRedirect() {
  if (typeof window !== "undefined") {
    window.location.replace("https://www.godaddy.com/offers/domain-airo");
  }
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 text-center">
      <p className="text-muted-foreground">
        Redirecting to{" "}
        <a
          href="https://www.godaddy.com/offers/domain-airo"
          className="text-primary underline"
        >
          GoDaddy
        </a>
        ...
      </p>
    </div>
  );
}
